import React, { useState, useEffect } from 'react'

export default function CuratorWidget(curatorFeedId) {
const feedID = curatorFeedId.curatorFeedId;
const {loadGrid, setLoadGrid} = useState('')  

  function loadScript(src, libraryId) {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.id = libraryId;
      document.body.appendChild(script);

      script.onload = () => {
        setTimeout(() => {
          resolve(true);
        }, 100);
      };
    });
  }
  useEffect(() => {
    loadScript('https://cdn.curator.io/published/' + `${feedID}` + '.js')
  }, [])
  
    return (
        <div id="curatorFeed" data-crt-feed-id={curatorFeedId}>
        </div>
    )
}